import { Truck, MessageCircle, BadgeCheck } from "lucide-react";

const BADGES = [
  { icon: BadgeCheck, label: "Secure Online Payment" },
  { icon: MessageCircle, label: "Quick WhatsApp Support" },
  { icon: Truck, label: "Fast Shipping Across India" },
];

export default function TrustBadges({ variant = "row" }) {
  if (variant === "compact") {
    return (
      <ul className="grid grid-cols-3 gap-3 border-y py-4" data-testid="trust-badges-compact">
        {BADGES.map(({ icon: Icon, label }) => (
          <li key={label} className="flex items-center gap-2 text-xs opacity-80" data-testid={`trust-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <Icon className="h-4 w-4 shrink-0" />
            <span className="leading-tight">{label}</span>
          </li>
        ))}
      </ul>
    );
  }
  return (
    <div className="border-y bg-muted/40" data-testid="trust-badges">
      <ul className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 grid grid-cols-1 sm:grid-cols-3 gap-6">
        {BADGES.map(({ icon: Icon, label }) => (
          <li key={label} className="flex items-center gap-3" data-testid={`trust-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <span className="w-10 h-10 border border-foreground/20 grid place-items-center shrink-0">
              <Icon className="h-4 w-4" />
            </span>
            <span className="label-xs">{label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
